import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "aktiveret",
  "use": "aktiveret-usage",
  "viewBox": "0 0 31.95 25.96",
  "content": "<symbol viewBox=\"0 0 31.95 25.96\" id=\"aktiveret\"><path d=\"M27 0L12 15.58 5 8.31 0 13.5 12 26 32 5.19z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/aktiveret.svg
// module id = uPGB
// module chunks = 1